export default [
    { header: "Dashboard", grantaccess: ['all'] },
    {
        title: "Home",
        icon: "mdi-home",
        to: "/dashboard",
        grantaccess: [ 'sysadmins', 'dataop', 'operators', 'bizpartners' ],
    },
    { header: "Customer Orders", grantaccess: [ 'operators' ] },
    {
        title: "Manage",
        icon: "mdi-view-list-outline",
        to: "/operator/customer-orders",
        grantaccess: [ 'operators']
    },
    { header: "Reports", grantaccess: [ 'operators' ] },
    {
        title: "Daily Order Transactions",
        icon: "mdi-database-clock",
        to: "/operator/report-daily",
        grantaccess: [ 'operators' ]
    },
    {
        title: "Monthly Order Transactions",
        icon: "mdi-database-clock",
        to: "/operator/report-monthly",
        grantaccess: [ 'operators' ]
    },
    { header: "Reports", grantaccess: [ 'bizpartners' ] },
    {
        title: "Daily Order Transactions",
        icon: "mdi-database-clock",
        to: "/bizpartner/report-daily",
        grantaccess: [ 'bizpartners' ]
    },
    {
        title: "Monthly Order Transactions",
        icon: "mdi-database-clock",
        to: "/bizpartner/report-monthly",
        grantaccess: [ 'bizpartners' ]
    },
    { header: "Users", grantaccess: [ 'bizpartners' ] },
    {
        title: "Operators",
        icon: "mdi-account-circle",
        to: "/bizpartner/operators",
        grantaccess: [ 'bizpartners' ]
    },
    { header: "Customer Orders", grantaccess: [ 'sysadmins', 'dataop' ] },
    {
        title: "Manage",
        icon: "mdi-view-list-outline",
        to: "/admin/customer-orders",
        grantaccess: [ 'sysadmins', 'dataop' ]
    },
    { header: "Business Partners", grantaccess: [ 'sysadmins' ] },
    {
        title: "Manage",
        icon: "mdi-view-list-outline",
        to: "/admin/business-partners",
        grantaccess: [ 'sysadmins' ]
    },
    { header: "Reports", grantaccess: [ 'sysadmins', 'dataop' ] },
    {
        title: "Daily Order Transactions",
        icon: "mdi-database-clock",
        to: "/admin/report-daily",
        grantaccess: [ 'sysadmins', 'dataop' ]
    },
    {
        title: "Monthly Order Transactions",
        icon: "mdi-database-clock",
        to: "/admin/report-monthly",
        grantaccess: [ 'sysadmins', 'dataop' ]
    },
    { header: "System Settings", grantaccess: [ 'sysadmins' ] },
    {
        title: "Order Types",
        icon: "mdi-database-cog",
        to: "/admin/system-order-types",
        grantaccess: [ 'sysadmins' ]
    },
    {
        title: "Order Status",
        icon: "mdi-database-cog",
        to: "/admin/system-order-status",
        grantaccess: [ 'sysadmins' ]
    },
    {
        title: "Order Extra Charges",
        icon: "mdi-database-cog",
        to: "/admin/system-order-remarks",
        grantaccess: [ 'sysadmins' ]
    },
    {
        title: "Order Regions",
        icon: "mdi-database-cog",
        to: "/admin/system-order-regions",
        grantaccess: [ 'sysadmins' ]
    },
    {
        title: "System Users",
        icon: "mdi-account-circle",
        to: "/admin/system-users",
        grantaccess: [ 'sysadmins' ]
    },
];
